import { render, staticRenderFns } from "./case-carousel.vue?vue&type=template&id=37f2333e&scoped=true"
import script from "./case-carousel.vue?vue&type=script&lang=js"
export * from "./case-carousel.vue?vue&type=script&lang=js"
import style0 from "./case-carousel.vue?vue&type=style&index=0&id=37f2333e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f2333e",
  null
  
)

export default component.exports